// Google Consent Mode v2 state.
// The matching `consent default` (all denied) is queued in public/index.html before the
// gtag config calls, so nothing is stored until the visitor makes a choice here.
// Keep CONSENT_KEY / CONSENT_VERSION in sync with the inline snippet in index.html.

export const CONSENT_KEY = 'hv_consent_v1';
export const CONSENT_VERSION = 1;
export const CONSENT_EVENT = 'hv:consent-settings';

export const readConsent = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(CONSENT_KEY) || 'null');
    if (raw && raw.version === CONSENT_VERSION) {
      return { analytics: raw.analytics === true, marketing: raw.marketing === true };
    }
  } catch (e) {
    // corrupt/blocked storage -> treat as no choice made
  }
  return null;
};

export const applyConsent = ({ analytics, marketing }) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', {
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
    analytics_storage: analytics ? 'granted' : 'denied'
  });
};

export const saveConsent = ({ analytics, marketing }) => {
  const record = {
    analytics: analytics === true,
    marketing: marketing === true,
    version: CONSENT_VERSION
  };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(record));
  } catch (e) {
    // storage unavailable - consent still applies for this page view
  }
  applyConsent(record);
  return record;
};

// Lets the footer / privacy policy reopen the banner so consent can be withdrawn.
export const openConsentSettings = () => window.dispatchEvent(new Event(CONSENT_EVENT));
